// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-gradient {
  display: inline-block;
  position: relative;
  overflow: hidden;
  width: 100%;
  font-family: "Roboto", sans-serif;
  transition: all 0.3s ease;
  padding: 1px;
  border-radius: 8.485px;
  background: #2B2B2B;
}
.input-gradient::before {
  /* content: "";
   position: absolute;
   top: -1px;
   left: -1px;
   right: -1px;
   bottom: -1px;
   background: conic-gradient(#D70F14, #E5661A, #F6D80B, #B5EF30, #67F248, #36C999, #068CED, #91921E, #8769DB, #DE3CC3,#D70F14);
   transform: scaleX(3);
   z-index: -1;
   animation: rotate-gradient 7s linear infinite;*/
}
.input-gradient:hover:not(:focus-within) {
  background: rgba(81, 86, 91, 0.45);
}
.input-gradient:hover:after {
  width: 100%;
}
.input-gradient label {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.input-gradient input {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 14px 50px 9px 23px;
  background: var(--primary-color);
  outline: none;
  border-radius: 8.485px;
  z-index: 1;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  letter-spacing: 1.95px;
  font-size: 13px;
  line-height: 149.68%;
  color: #F4F4F4;
  border: none;
  transition: all 0.3s ease;
  /* &:hover:not(:focus){
     background: rgba(81, 86, 91, 0.45);
     border-color:#353B42;
   }*/
}
.input-gradient input:focus ~ span, .input-gradient input:not(:placeholder-shown) ~ span {
  font-size: 12px;
  line-height: 18px;
  color: #F4F4F4;
  transform: translateY(-14px);
}
.input-gradient__label {
  position: absolute;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  left: 23px;
  font-weight: 400;
  letter-spacing: 1.95px;
  font-size: 15px;
  line-height: 100%;
  color: #BBB7B7;
  transition: all 0.3s ease;
  z-index: 1;
  -webkit-user-select: none;
          user-select: none;
  cursor: text;
}
.input-gradient__message {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--primary-color);
  border-radius: 8.485px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  padding-left: 49px;
}
.input-gradient__message.active {
  opacity: 1;
  visibility: visible;
  z-index: 1;
}
.input-gradient__message-text {
  color: #BBB7B7;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.input-gradient.error input {
  border-color: #ff0000;
}
.input-gradient.error input:hover {
  border-color: #ff0000;
}
.input-gradient.error span {
  color: #ff0000 !important;
}

@keyframes rotate-gradient {
  0% {
    transform: scale(9, 3) rotate(0);
  }
  50% {
    transform: scale(9, 3) rotate(180deg);
  }
  99.9999% {
    transform: scale(9, 3) rotate(360deg);
  }
  100% {
    transform: scale(9, 3) rotate(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/InputGradient/InputGradient.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAEE;EACC;;;;;;;;;kDAAA;AASH;AAGI;EACE,kCAAA;AADN;AAII;EACE,WAAA;AAFN;AAKE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAHJ;AAKE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,2BAAA;EACA,gCC5CG;ED6CH,aAAA;EACA,sBAAA;EACA,UAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EAEA,yBAAA;EACA;;;KAAA;AADJ;AAMM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;AAJR;AAQE;EACE,kBAAA;EAEA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AAPJ;AASE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gCC9FG;ED+FH,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAPJ;AAQI;EACE,UAAA;EACA,mBAAA;EACA,UAAA;AANN;AAQI;EACE,cAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANN;AAUI;EACE,qBAAA;AARN;AAUM;EACE,qBAAA;AARR;AAWI;EACE,yBAAA;AATN;;AAcA;EACE;IACE,gCAAA;EAXF;EAaA;IACE,qCAAA;EAXF;EAaA;IACE,qCAAA;EAXF;EAaA;IACE,gCAAA;EAXF;AACF","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.input-gradient{\r\n  display: inline-block;\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  font-family: \"Roboto\",sans-serif;\r\n  transition: all 0.3s ease;\r\n  padding: 1px;\r\n  border-radius: 8.485px;\r\n  background: #2B2B2B;\r\n  &::before {\r\n   /* content: \"\";\r\n    position: absolute;\r\n    top: -1px;\r\n    left: -1px;\r\n    right: -1px;\r\n    bottom: -1px;\r\n    background: conic-gradient(#D70F14, #E5661A, #F6D80B, #B5EF30, #67F248, #36C999, #068CED, #91921E, #8769DB, #DE3CC3,#D70F14);\r\n    transform: scaleX(3);\r\n    z-index: -1;\r\n    animation: rotate-gradient 7s linear infinite;*/\r\n  }\r\n  &:hover{\r\n    &:not(:focus-within){\r\n      background: rgba(81, 86, 91, 0.45);\r\n    }\r\n\r\n    &:after{\r\n      width: 100%;\r\n    }\r\n  }\r\n  label{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  input{\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n    padding: 14px 50px 9px 23px;\r\n    background: $main;\r\n    outline: none;\r\n    border-radius: 8.485px;\r\n    z-index: 1;\r\n    font-family: \"Roboto\",sans-serif;\r\n    font-weight: 400;\r\n    letter-spacing: 1.95px;\r\n    font-size: 13px;\r\n    line-height: 149.68%;\r\n    color: #F4F4F4;\r\n    border:none;\r\n    //border-bottom: 1px solid $additional;\r\n    transition: all 0.3s ease;\r\n    /* &:hover:not(:focus){\r\n       background: rgba(81, 86, 91, 0.45);\r\n       border-color:#353B42;\r\n     }*/\r\n    &:focus,&:not(:placeholder-shown){\r\n      ~ span{\r\n        font-size: 12px;\r\n        line-height: 18px;\r\n        color: #F4F4F4;\r\n        transform: translateY(-14px);\r\n      }\r\n    }\r\n  }\r\n  &__label{\r\n    position: absolute;\r\n    //display: inline;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    left: 23px;\r\n    font-weight: 400;\r\n    letter-spacing: 1.95px;\r\n    font-size: 15px;\r\n    line-height: 100%;\r\n    color: #BBB7B7;\r\n    transition: all 0.3s ease;\r\n    z-index: 1;\r\n    user-select:none;\r\n    cursor: text;\r\n  }\r\n  &__message{\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: $main;\r\n    border-radius: 8.485px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 0;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transition: all 0.3s ease;\r\n    padding-left: 49px;\r\n    &.active{\r\n      opacity: 1;\r\n      visibility: visible;\r\n      z-index:1;\r\n    }\r\n    &-text{\r\n      color: #BBB7B7;\r\n      font-family: \"Roboto\",sans-serif;\r\n      font-size: 15px;\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      line-height: normal;\r\n    }\r\n  }\r\n  &.error{\r\n    input{\r\n      border-color:#ff0000;\r\n\r\n      &:hover{\r\n        border-color:#ff0000\r\n      }\r\n    }\r\n    span{\r\n      color:#ff0000 !important;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes rotate-gradient {\r\n  0% {\r\n    transform: scale(9, 3) rotate(0);\r\n  }\r\n  50% {\r\n    transform: scale(9, 3) rotate(180deg);\r\n  }\r\n  99.9999% {\r\n    transform: scale(9, 3) rotate(360deg);\r\n  }\r\n  100% {\r\n    transform: scale(9, 3) rotate(0);\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
